/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomCategory.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getLangValue } from '../../../utils/Generic';

const RoomCategory = (props) => {
  const { category, className } = props;
  if (!category) return null;

  const label = getLangValue(category, props.lang, 'name');
  return (
    <span className={`room-info__category ${className || ''}`} >
      {props.category.icon
       && <i className={`room-info__icon fa mr-1 ${props.category.icon}`} />
      }
      {props.showLabel ? label : null}
    </span>
  );
};

RoomCategory.propTypes = {
  category: PropTypes.object,
  showLabel: PropTypes.bool,
};

RoomCategory.defaultProps = {
  showLabel: true,
};

export default connect((state) => ({
  lang: state.i18nState.lang,
}))(RoomCategory);
